// Select the elements you want to wrap
// setTimeout(() => {
//     const getAllTitle = document.querySelectorAll('.tagged-product-container')
//     console.log('getAllTitle >>',getAllTitle)
//     const title = document.querySelector('.product-title');
// const price = document.querySelector('.product-price');

// console.log('title >>',title)

// // Create the new parent div
// const wrapper = document.createElement('div');
// wrapper.className = 'product_details_wrap'; // add your class if needed
// wrapper.style.display = 'flex'; // example (optional)

// // Insert the wrapper before the title
// title.parentNode.insertBefore(wrapper, title);

// // Move the title & price inside the wrapper
// wrapper.appendChild(title);
// wrapper.appendChild(price); 
// }, 10000);


setTimeout(() => {
    const allProducts = document.querySelectorAll('.tagged-product-container');

    allProducts.forEach(product => {
        const title = product.querySelector('.product-title');
        const price = product.querySelector('.product-price');

        if (!title || !price) return;

        const wrapper = document.createElement('div');
        wrapper.className = 'product_details_wrap';
        // wrapper.style.display = 'flex'; 

        title.parentNode.insertBefore(wrapper, title);

        wrapper.appendChild(title);
        wrapper.appendChild(price);
    });

}, 10000);
